import React, {createContext, useEffect, useState} from "react";
import jwt_decode from "jwt-decode";
import CustomModal from "./CustomModal";
import {useNavigate} from 'react-router-dom'
import PropTypes from 'prop-types';

const AuthContext = createContext();

export const AuthProvider = ({children}) => {
  const navigate = useNavigate()
  const getSession = () => {
    return JSON.parse(localStorage.getItem('session'));
  };

  const setSessionInLocalStorage = (token) => {
    localStorage.setItem('session', JSON.stringify(token));
    return true;
  };

  const [session, setSession] = useState(getSession() || '');
  const [isTokenExpiredDialogOpen, setTokenExpiredDialogOpen] = useState(false);

  const setAuth = (token) => {
    setSession(token);
    setSessionInLocalStorage(token);
  };

  useEffect(() => {
    const checkTokenExpiration = () => {
      const token = session?.accessToken;

      if (token) {
        try {
          const decodedToken = jwt_decode(token);

          const expirationTime = decodedToken.exp * 1000;
          const currentTime = new Date().getTime();

          if (currentTime > expirationTime) {
            setTokenExpiredDialogOpen(true);
          }
        } catch (error) {
          console.error("Error decoding the token:", error);
        }
      }
    };

    // Invoke the checkTokenExpiration function on component mount
    checkTokenExpiration();

    // Set up interval to check token expiration periodically (adjust the interval as needed)
    const intervalId = setInterval(checkTokenExpiration, 300000); // Check every 5 minuts

    // Clear the interval on component unmount
    return () => clearInterval(intervalId);
  }, [session]);


  const handleCloseTokenExpiredDialog = () => {
    setTokenExpiredDialogOpen(false);
    sessionStorage.removeItem('mySnap');
    localStorage.removeItem('session');

    if (
      session.user === 'SUP_ADMIN_COMITE' ||
      session.user === 'SUP_ADMIN_PJ' ||
      session.user === 'SUP_ADMIN_EVALUATEUR' ||
      session.user === 'SUP_ADMIN_RH' ||
      session.user === 'SUP_ADMIN_CANDIDAT'
    ) {
      session.roles.pop()
      session.roles.push("ROLE_SUPER_ADMIN")
      session.user = 'ROLE_SUPER_ADMIN'
      setAuth(session)
      navigate('/Dashboard')
      window.location.reload(false)
    } else {

      navigate('/login')

      if ('caches' in window) {


        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name).then(() => {
            })
          })
        })
        localStorage.clear()
        sessionStorage.clear()
      }
    }
  };

  return (
    <AuthContext.Provider value={{session, setAuth}}>
      {children}
      <CustomModal open={isTokenExpiredDialogOpen} onClose={handleCloseTokenExpiredDialog}/>
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default AuthContext;
